import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import * as QRCode from 'qrcode';

@Component({
  selector: 'ez-authenticator',
  imports: [
    MatButtonModule,
  ],
  templateUrl: './authenticator.component.html',
  styleUrls: ['./authenticator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticatorComponent implements OnInit {
  authUrl: string = '';
  manualKey: string = '';

  readonly #elementRef = inject(ElementRef);

  ngOnInit(): void {
    const getAttribute = this.#elementRef.nativeElement.getAttribute.bind(this.#elementRef.nativeElement);
    const canvas = document.getElementById('qr-code') as HTMLCanvasElement;

    this.authUrl = getAttribute('auth-url');
    this.manualKey = getAttribute('manual-key');

    QRCode.toCanvas(canvas, this.authUrl);
  }
}
